import React, { Component } from 'react';
import { Dropdown, Image } from 'react-bootstrap';

class MultiSelect extends Component {
    constructor(props){
        super(props);
        this.state = {
            options: props.optionList,
            selectedOption: props.selected
        }
    }

    selectOption = (id, type) =>{
        const { updateValue, optionList, triggerIndex } = this.props;
        const selectOption = this.state.selectedOption;
        let selectedOption = id > 0 ? [...selectOption, id] : selectOption;
        if(selectOption.includes(id)){
            selectedOption = selectOption.filter(item => item != id);
        }
        let values = selectedOption.join(",");
        if(type == 'all'){
            const dropdownMenu = document.querySelector('.options-dropdown');
            selectedOption = selectedOption.length == optionList.length ? [] : optionList.map(item => item.id);
            values = selectedOption.join(",");
            dropdownMenu.click();
        }
        this.setState({ selectedOption }, () => updateValue(triggerIndex, values));
    }
      
    componentDidUpdate(prevProps){
      if(prevProps.optionList != this.props.optionList){
          this.setState({options:this.props.optionList})
      }
    }

    onSearchOption = (event) => {
        const optionList = this.props.optionList;
        const results = optionList.filter(option => option.name.toLowerCase().includes(event.target.value.toLowerCase()))
        this.setState({ options: results });
    }

    render() {
        const { options, selectedOption } = this.state;
        const { triggerType, optionList } = this.props;
        const selectInfoMsg = `Select ${triggerType} ${(triggerType == "AI-Recommendation" || triggerType == "Sentiment") ? 'Score' : ''}`;
        const noOptionMsg = `No ${triggerType} Available`;
        const selectMsg = selectedOption.length > 0 ? selectedOption.length == 1 ? options.find(option => option.id == selectedOption[0]).name :`${selectedOption.length == optionList.length ? 'All' : selectedOption.length} selected` : selectInfoMsg;

        return <Dropdown className="w-100 options-dropdown" autoClose="outside">
        <Dropdown.Toggle variant="outline-secondary" className="border-gray w-100 d-flex align-items-center">
          <label className="mb-0 flex-grow-1 overflow-hidden align-items-center text-start" htmlFor={`filter_0`}>
            <span className="text-gray-800 text-ellipsis fw-medium ps-0">{selectMsg}</span>
          </label>
        </Dropdown.Toggle>
        <Dropdown.Menu className="w-100 overflow-auto p-3" style={{ maxHeight: 400 }}>
            <div className="d-flex align-items-center p-2">
              <label className="mb-0 flex-grow-1 fw-normal cursor-pointer" htmlFor="tri-searchNetwork">Select All</label>
              <input className="form-check-input cursor-pointer m-0" type="checkbox" id="tri-searchNetwork" onChange={event=>this.selectOption(0, 'all')} checked={selectedOption.length == this.props.optionList.length} />
          </div>
          {triggerType == 'Social Network' ? <div className="form-group my-3">
            <input type="text" className="form-control" placeholder="Search your network" onChange={event=>this.onSearchOption(event)}/>
          </div> : null}
          {options && options.length > 0 ? options.map(option=> <div className='dropdown-item d-flex p-2' key={option.id}>
            <label className="d-flex flex-grow-1 overflow-hidden align-items-center m-0 cursor-pointer" htmlFor={`tri-network-${option.id}`}>
              <span className="symbol symbol-20 me-2">
                <Image className="img-fluid h-100" src={option.imageUrl} height={20} width={20} alt={option.id} />
              </span>
              <span className="text-gray-800 text-ellipsis fw-medium">{option.name}</span>
            </label>
            <input className="form-check-input flex-shrink-0 cursor-pointer" type="checkbox" id={`tri-network-${option.id}`} checked={selectedOption.includes(option.id)} 
            onChange={() => this.selectOption(option.id, null)} />
          </div>):
           <div className="py-4"><h6 className="text-center fs-9 mb-0 text-gray-700">{noOptionMsg}</h6></div>}
        </Dropdown.Menu>
      </Dropdown>
    }
}

export default MultiSelect